export default {
  'menu.home': 'Biểu đồ thống kê',
  'menu.post-management': 'Quản lý bài viết',
  'menu.post-management.list': 'Danh sách bài viết',
  'menu.post-management.category': 'Danh mục bài viết',
  'menu.post-management.add': 'Tạo bài viết',
  'menu.post-management.edit': 'Sửa bài viết',
  'menu.service-management': 'Quản lý dịch vụ',
  'menu.customer-management': 'Quản lý khách hàng',
  'menu.customer-management.list': 'Danh sách khách hàng',
  'menu.customer-management.detail': 'Lịch sử đặt vé',
  'menu.staff-management': 'Quản lý CBCNV',
  'menu.staff-management.list': 'Danh sách nhân viên',
  'menu.staff-management.role': 'Danh sách chức vụ',
  'menu.interface-management': 'Quản lý giao diện',
  'menu.interface-management.banner': 'Quản lý banner',
  'menu.login': 'Đăng nhập',
  'menu.exception.404': 'Không tìm thấy',
  'menu.ticket-management': 'Quản lý vé',
  'menu.feedback-management': 'Quản lý phản hồi',
  'menu.feedback-management.list': 'Danh sách phản hồi',
  'menu.room-post-management': 'Quản lý đăng bài phòng trọ',
  'menu.room-post-management.list': 'Danh sách bài đăng',
  'menu.miniapp-link': 'Liên kết mini app',
  'menu.miniapp-link.list': 'Tạo deeplink và QR',
  'menu.miniapp-link.partners': 'Quản lý liên kết xã',
  'menu.question-management': 'Quản lý câu hỏi',
  'menu.question-management.list': 'Danh sách câu hỏi',
  'menu.question-management.leaderboard': 'Bảng xếp hạng',
  'menu.appointment-management': 'Quản lý lịch hẹn',
  'menu.appointment-management.list': 'Danh sách lịch hẹn',
  'menu.law': 'Thư viện pháp luật',
  'menu.law.list': 'Bài viết dự thảo',
  'menu.law.list-1': 'Bài viết công văn',
  'menu.law.list-2': 'Bài viết Quyết định',
  'menu.chi-dao-dieu-hanh': 'Chỉ đạo điều hành',
  'menu.chi-dao-dieu-hanh.lich-tiep-cong-dan': 'Lịch tiếp công dân',
  'menu.chi-dao-dieu-hanh.van-ban-chi-dao': 'Văn bản chỉ đạo',
  'menu.chi-dao-dieu-hanh.thong-bao-khan': 'Thông báo khẩn',
  'menu.van-ban': 'Văn bản chỉ đạo',
  'menu.van-ban.van-ban-chi-dao': 'Văn bản chỉ đạo điều hành',
  'menu.van-ban.van-ban-quy-pham-phap-luat': 'Văn bản quy phạm pháp luật',
  'menu.dan-cu-doi-song.lich-tiem-chung': 'Lịch tiêm chủng',
  'menu.dan-cu-doi-song.lich-cat-dien-nuoc': 'Lịch cắt điện nước',
  'menu.dan-cu-doi-song.tin-tuyen-dung': 'Tin tuyển dụng',
  'menu.dan-cu-doi-song': 'Dân cư - Đời sống',
  'menu.van-hoa-xa-hoi': 'Văn hóa - Xã hội',
  'menu.van-hoa-xa-hoi.van-hoa-xa-hoi': 'Văn hóa - Xã hội',
  'menu.van-hoa-xa-hoi.le-hoi-&-su-kien': 'Lễ hội & Sự kiện',
  'menu.niem-yet-cong-khai': 'Niêm yết công khai',
  'menu.niem-yet-cong-khai.list': 'Danh sách niêm yết',

  // Travel Management
  'menu.travel-management': 'Bản đồ du lịch',
  'menu.travel-management.list': 'Danh sách địa điểm',
  'menu.travel-management.add': 'Thêm địa điểm',
  'menu.travel-management.edit': 'Sửa địa điểm',
  // Planning Management
  'menu.planning-management': 'Bản đồ quy hoạch',
  'menu.planning-management.list': 'Danh sách layer',
  'menu.planning-management.add': 'Thêm layer',
  'menu.planning-management.edit': 'Sửa layer',
};
